const TRANSITION_DURATION = 300;

export default function transitionHeight($timeout, $$rAF) {
  'ngInject';

  return {
    compile: () => ({ pre }),
  };

  function pre($scope, $element, $attrs) {
    let timer = null;

    $scope.$watch($attrs.transitionHeight, onChange);
    const getHeight = () => `${$element[0].offsetHeight}px`;
    const getChildHeight = () => `${$element.children()[0].offsetHeight}px`;

    function onChange() {
      const oldHeight = getHeight();

      if (oldHeight === '0px') {
        return;
      }

      $scope.$$postDigest(() => {
        const newHeight = getChildHeight();

        if (oldHeight === newHeight) {
          return;
        }

        $element.css({
          overflow: 'hidden',
          height: oldHeight,
        });

        $timeout.cancel(timer);

        $$rAF(() => {
          $element.css({
            height: newHeight,
          });

          timer = $timeout(completeTransition, TRANSITION_DURATION, false);
        });
      });
    }

    function completeTransition() {
      $element.css({
        overflow: '',
        height: '',
      });
    }
  }
}
